export const BUILDING_PERMIT_QUICK_NAVIGATION = [
  {
    label: 'A.1 Identifikační údaje',
    target: 'a1Heading',
  },
  {
    label: 'A.1.1 Údaje o stavbě',
    target: 'a11Heading',
    className: 'pl-7',
  },
  {
    label: 'A.1.2 Údaje o zpracovateli dokumentace',
    target: 'a12Heading',
    className: 'pl-7',
  },
  {
    label: 'A.2 Seznam vstupních podkladů',
    target: 'a2Heading',
  },
  {
    label: 'A.3 TEA',
    target: 'a3Heading',
  },
  {
    label: 'A.4 Atributy stavby',
    target: 'a4Heading',
  },
]
